<template>
    <div class="input-details">
        <template v-if="externalSource === false">
            <h6>Input</h6>
            <p>Datacenter: {{nodeDetails.datacenter ? nodeDetails.datacenter : 'No datacenter given'}}</p>
            <p>Global status : <i :class="iconClass"></i> <strong :class="textClass">{{textValue}}</strong></p>
            <div class="main-and-backup">
                <div class="main-info">
                    <h6>Main</h6>
                    <p>Port: {{nodeDetails.port_main ? nodeDetails.port_main : 'No main port given'}}</p>
                    <p>Ip: {{nodeDetails.multicast_network_ip_main ? nodeDetails.multicast_network_ip_main : 'No main multicast network ip given'}}</p>
                    <p>Source: {{nodeDetails.multicast_network_src_main ? nodeDetails.multicast_network_src_main : 'No main multicast network source given'}}</p>
                </div>
                <div class="back-up-info">
                    <h6>Backup</h6>
                    <p>Port: {{nodeDetails.port_backup ? nodeDetails.port_backup : 'No backup port given'}}</p>
                    <p>Ip: {{nodeDetails.multicast_network_ip_backup ? nodeDetails.multicast_network_ip_backup : 'No backup multicast network ip given'}}</p>
                    <p>Source: {{nodeDetails.multicast_network_src_backup ? nodeDetails.multicast_network_src_backup : 'No backup multicast network source given'}}</p>
                </div>
            </div>
        </template>
        <template v-else>
            <h6>Input</h6>
            <p>External source. No info</p>
        </template>
    </div>
</template>

<script>

export default {

    components: {
    },

    props: {
        nodeDetails: {
            type: Object,
            required: true
        }

    },

    data: function(){
        return {
            iconClassByStatus: {
                'success': 'el-icon-success text-success',
                'unstable': 'el-icon-warning text-warning',
                'failure': 'el-icon-error text-danger',
            },
            textClassByStatus: {
                'success': 'text-success',
                'unstable': 'text-warning',
                'failure': 'text-danger',
            },
            textValueByStatus: {
                'success': 'OK',
                'unstable': 'WARNING',
                'failure': 'ERROR',
            }
        };
    },

    computed: {
        externalSource() {
            return this.nodeDetails.source_type === 'external';
        },
        iconClass() {
            return this.iconClassByStatus[this.nodeDetails.status];
        },
        textClass() {
            return this.textClassByStatus[this.nodeDetails.status];
        },
        textValue() {
            return this.textValueByStatus[this.nodeDetails.status];
        }
    },

    mounted: function(){

    },

    methods: {
    },
};
</script>

<style lang="scss">
.input-details {
    .main-and-backup {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .back-up-info {
            margin-left: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Monitoring/inputDetails.vue